import { render } from "./MosaicoSalas2View.vue?vue&type=template&id=80035fe2&scoped=true"
import script from "./MosaicoSalas2View.vue?vue&type=script&lang=js"
export * from "./MosaicoSalas2View.vue?vue&type=script&lang=js"

import "./MosaicoSalas2View.vue?vue&type=style&index=0&id=80035fe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80035fe2"]])

export default __exports__